<div class="container" *ngIf="pageActionService.pageActions">
  <collab-comp-header  [showPagePermission]="showPagePermission" [logoName]="'Ascendion_AVA_White.svg'" headerTheme='theme1' (onLogOut)="logout()" (onContactUsClick)="onContactUsClick()" [menuList]="platformMainMenu"></collab-comp-header>
<main>
<div class="landingCarouselposition" >
 <collab-comp-carousel [topCarousel]="topCarousel" [transition]="transition" [translate]="translate" [interval]="interval" ></collab-comp-carousel>
</div>
  <div class="container__landing--2col">
    <div class="prod-container">
      <div class="container__tablist"><h1 class="heading_studio">Ascendion AVA STUDIOS</h1></div>
      <div class="container__tabBody" *ngIf="productDetails.length > 0">
        <router-outlet></router-outlet>
        <collab-comp-button type="button" class="button--secondary content__align--center" *ngIf="productDetails.length > 12"
                            [buttonConfig]="showAllStudioBtnConfig">
        </collab-comp-button>
      </div>
    </div>
  </div>

  <!-- show reel video -->
  <div *ngIf="isClient">
    <div class="reel_video">
      <div class="reel_container">
        <h3 class="white text--bold">SHOWREEL</h3>
        <div class="white">This has been our journey to make the world class products</div>
        <button class="chevron_button_comment">
          <collab-comp-img-generator imageType="image" src="../../../assets/icons/video_icon.png" alt="" ></collab-comp-img-generator>
        </button>
      </div>
    </div>
    <app-carousel></app-carousel>
  </div>
</main>
<footer>
  <div class="div_line">
    <div class="div_links">
      <a class="strong" href="javascript:void(0);" (click)="onContactUsClick()">Contact Us</a>
      <a class="strong external_link" href="https://dev.avateam.io/help/#t=AVA%2FPrivacy_Policy.htm" target="_blank" rel="noopener" >Privacy Policy
        <collab-comp-img-generator class="external_icon" imageType="image" imgUrl='assets/Export.svg' imageAltText="visit privacy policy" role="link" aria-label="external_link icons"></collab-comp-img-generator>
      </a>
      <a class="strong external_link" href="https://dev.avateam.io/help/#t=AVA%2FTerms_Of_Use.htm" target="_blank" rel="noopener">Terms of Use<collab-comp-img-generator class="external_icon" imageType="image" imgUrl='assets/Export.svg' imageAltText="visit terms of use"
        aria-label="external_link icons" role="link"></collab-comp-img-generator></a>
      <a class="strong external_link" href="https://dev.avateam.io/help/#t=AVA%2FCookie_Policy.htm" target="_blank" rel="noopener">Cookie Policy<collab-comp-img-generator class="external_icon" imageType="image" imgUrl='assets/Export.svg' imageAltText="visit cookie policy"
        aria-label="external_link icons" role="link"></collab-comp-img-generator></a>
    </div>
    <div class="div_images">
      <a href="https://www.linkedin.com/company/ascendion/mycompany/" target="_blank" rel="noopener"><collab-comp-img-generator imageType="image" imgUrl="assets/icons/linkedin_icon.png" imageAltText="Visit ascendion linkedin " role="link" aria-label="Visit linkedin Ascendion page - opens a new window"></collab-comp-img-generator></a>
      <a href="https://www.youtube.com/@ascendioninc" target="_blank" rel="noopener"><collab-comp-img-generator imageType="image" imgUrl="assets/icons/youtube_icon.png" imageAltText=" Visit ascendion youtube" role="link" aria-label="Visit youtube Ascendion page - opens a new window"></collab-comp-img-generator></a>
      <!-- <a href="javascript:void(0);" target="_blank" rel="noopener"><collab-comp-img-generator imageType="image" imgUrl="assets/icons/twitter_icon.png" imageAltText="Visit ascendion twitter" role="link" aria-label="Visit twitter Ascendion page - opens a new window"></collab-comp-img-generator></a> -->
    </div>
  </div>
  <div>
    <div class="hr_line">
      <hr />
    </div>
  </div>
  <div>
    <p class="copy_rights">&copy; 2023 Ascendion. All Rights Reserved.</p>
  </div>
  <div *ngIf="footer">
  <p class="copy_rights version-cursor" (click)="onVersionClick()"> &nbsp;Version {{versionui}}</p>
  <collab-comp-modal id="Version" [modalConfig]="versionModalConfig" (onSubmitted)="onVersionSubmit()">
    <collab-comp-img-generator imageType="image" imgUrl="../../../assets/Ascendion_ava_logo.svg"
      class="version-heading"></collab-comp-img-generator>
    <div>
      <div class="version-number">Version</div>
      <div class="version-number">Last updated</div>
    </div>
    <div>
      <p class="version-number-2">{{versionui}}</p>
      <div class="version-number-2">{{timestamp |date:'dd/MM/yyyy'}}</div>
    </div>
    <div class="version-description">This is version {{versionui}} of the Ascendion AVA Platform.
      It includes the following features:</div>
  <div class="version-description">
      • A user-friendly interface • Support English language • An integrated help system • Studios Offerings- ITA, IAF,
      OneView, Data Modernization, MLOps, ADE • Regular updates and bug fixes.
  </div>
    <p class="version-copyrights"> &copy; 2023 Ascendion. All Rights Reserved</p>
  </collab-comp-modal>
  </div>
</footer>
</div>

